module.exports = __webpack_public_path__ + "static/media/bac.666c602f.jpeg";